import { render } from "./PageForm.vue?vue&type=template&id=323fd42a&scoped=true"
import script from "./PageForm.vue?vue&type=script&lang=js"
export * from "./PageForm.vue?vue&type=script&lang=js"

import "./PageForm.vue?vue&type=style&index=0&id=323fd42a&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323fd42a"]])

export default __exports__